var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M.3 0H27v20H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3.5 0 10.1 7.5L23.8 0H27v2.6L17 10l10 7.5V20h-3.3l-10-7.5-10 7.5H.3v-2.5l10-7.4-10-7.4V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "m18 11.7 9 6.6V20l-11.3-8.3zm-7.7.8.3 1.5-8 6H.3zM27 0v.1L16.6 8l.1-1.9L25 0zM.3 0l10 7.3H7.8L.3 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.4 0v20H17V0zM.4 6.7v6.6H27V6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M.3 8v4H27V8zm11.4-8v20h4V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.3 8.5h16.2v14.4s.5 2.2-6.8 5.5c2.6-.3 5.5-3.1 5.5-3.1s1.2-1.5 1.8-.7q.8 1.2 1.5 1.6c.4.3.7 1.3.1 2s-1.6.7-1.9-.1c-.4.2-3 3.3-8.3 3.4-5.3 0-8.3-3.5-8.3-3.5s-.7 1.2-1.7.3c-1-1.2-.3-2-.3-2s.9-.4 1.1-.8c.4-.4.5-1 1.2-1 .8 0 1 .7 1 .7s2.8 2.8 5.7 3.2c-6.6-3.2-6.8-5.1-6.8-5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006129",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m32.7 9 15.5-.2v13.9c0 1.8-3 3.6-7.8 6-4.9-2.6-7.7-4.1-7.7-6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffc72c",
    strokeWidth: 0.2,
    d: "m34.8 11 1-1.4.9 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M36 10.5a.2.2 0 1 1-.4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M35 12h1.4l-.1-.3c.7-.1.5-.8 1.1-.8.2 0-.3.2-.3.2s-.4.3-.2.4q.2.1.2-.2s.6-.2.5-.5-1 .2-1 .2h-.5q0-.3-.4-.4-.3.2-.3.4h-1.3q-.2.1.6.4l.4.3zm.1-.3h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M35.1 11.7h1.2m-1.3.2h1.4l-.1-.2c.7-.1.5-.8 1.1-.8.2 0-.3.2-.3.2s-.4.3-.2.4q.2.1.2-.2s.6-.2.5-.5-1 .2-1 .2h-.5q0-.3-.4-.4-.3.2-.3.4h-1.3q-.2.1.6.4l.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M34.6 11s0 .5.5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.6 11s0 .5.5.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m34.5 11 .2-.6-.1-.3q0-.3-.2-.5l-.3.6.2.5-.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M36 9.7a.2.2 0 1 1-.4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffc72c",
    strokeWidth: 0.2,
    d: "m34.8 13.6.9-1.3.9 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M35.9 13.1a.2.2 0 1 1-.4 0 .2.2 0 0 1 .4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M35 14.6h1.4l-.2-.3c.8 0 .6-.7 1.2-.8l-.3.3s-.4.3-.2.4q.1.1.2-.2c0-.1.6-.2.5-.6-.2-.3-1 .2-1 .2H36q0-.2-.3-.3l-.3.3H34s0 .4.7.4q.1.3.4.3zm0-.3h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M35 14.3h1.2m-1.3.3h1.5l-.2-.3c.8 0 .6-.7 1.2-.8l-.3.3s-.4.3-.2.4q.1.1.2-.2c0-.1.6-.2.5-.6-.2-.3-1 .2-1 .2H36q0-.2-.3-.3l-.3.3H34s0 .4.7.4q.1.3.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M34.5 13.6s.1.6.5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.5 13.6s.1.6.5.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m34.4 13.6.2-.5q-.2-.3 0-.4 0-.2-.3-.5l-.2.7.1.4v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M35.9 12.3a.2.2 0 1 1-.4 0 .2.2 0 0 1 .4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffc72c",
    strokeWidth: 0.2,
    d: "m34.8 16.3.9-1.4.9 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M35.8 15.7a.2.2 0 1 1-.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M35 17.2h1.3l-.1-.2c.7-.2.5-.8 1.2-.8l-.4.2q-.2.1-.2.4.3.1.2-.2s.6-.2.6-.5c-.2-.3-1 .2-1 .2H36l-.3-.4q-.4.2-.4.4H34q-.2.1.6.4l.4.3zm0-.2h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M35 17h1.2m-1.3.2h1.4l-.1-.2c.7-.2.5-.8 1.2-.8l-.4.2q-.2.1-.2.4.3.1.2-.2s.6-.2.6-.5c-.2-.3-1 .2-1 .2H36l-.3-.4q-.4.2-.4.4H34q-.2.1.6.4l.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M34.5 16.3s0 .5.5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.5 16.3s0 .5.5.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m34.4 16.3.2-.6-.1-.4q.1-.2-.2-.4l-.3.6.2.5v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M35.8 15a.2.2 0 1 1-.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffc72c",
    strokeWidth: 0.2,
    d: "m36.5 19.1.9-1.3 1 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M37.6 18.6a.2.2 0 1 1-.4 0 .2.2 0 0 1 .4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M36.7 20H38l-.2-.2c.8-.1.6-.8 1.2-.8l-.3.3s-.4.2-.2.4l.2-.2c0-.1.6-.2.5-.6-.2-.3-1 .2-1 .2h-.5q0-.2-.4-.3l-.3.3h-1.4q-.2.1.7.4.1.3.4.3zm0-.2H38Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M36.8 19.8h1.1m-1.2.3H38l-.2-.3c.8-.1.6-.8 1.2-.8l-.3.3s-.4.2-.2.4l.2-.2c0-.1.6-.2.5-.6-.2-.3-1 .2-1 .2h-.5q0-.2-.4-.3l-.3.3h-1.4q-.2.1.7.4.1.3.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M36.2 19.1s.1.6.5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M36.2 19.1s.1.6.5.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M36.1 19.1q0-.2.3-.5l-.2-.4q.1-.3-.2-.5l-.2.7.1.4v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M37.6 17.8a.2.2 0 1 1-.4 0 .2.2 0 0 1 .4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffc72c",
    strokeWidth: 0.2,
    d: "m34.5 21.4 1-1.3.9 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M35.6 21a.2.2 0 1 1-.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M34.7 22.4h1.4l-.1-.3c.7 0 .5-.7 1.1-.8.2 0-.3.3-.3.3s-.4.3-.2.4q.2.1.2-.2c0-.1.6-.2.5-.6s-1 .2-1 .2h-.5q0-.2-.4-.3l-.3.3h-1.3s0 .4.6.4l.4.3zm.1-.3H36Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.8 22.1H36m-1.3.3h1.4l-.1-.3c.7 0 .5-.7 1.1-.8.2 0-.3.3-.3.3s-.4.3-.2.4q.2.1.2-.2c0-.1.6-.2.5-.6s-1 .2-1 .2h-.5q0-.2-.4-.3l-.3.3h-1.3s0 .4.6.4l.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M34.3 21.4s0 .6.5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.3 21.4s0 .6.5.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m34.2 21.4.2-.5-.1-.4q0-.2-.3-.5l-.3.7.2.4-.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M35.6 20.1a.2.2 0 1 1-.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffc72c",
    strokeWidth: 0.2,
    d: "m34.6 24.2.9-1.4 1 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M35.7 23.7a.2.2 0 1 1-.4 0 .2.2 0 0 1 .4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M34.8 25.2h1.4l-.2-.3c.8-.1.6-.8 1.2-.8l-.3.3s-.4.2-.2.4l.2-.2c0-.2.6-.2.5-.6s-1 .2-1 .2H36q0-.2-.4-.3l-.3.3h-1.4q-.2.1.7.4.1.2.4.3zm0-.3H36Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.9 24.9H36m-1.2.3h1.4l-.2-.3c.8-.1.6-.8 1.2-.8l-.3.3s-.4.2-.2.4l.2-.2c0-.2.6-.2.5-.6s-1 .2-1 .2H36q0-.2-.4-.3l-.3.3h-1.4q-.2.1.7.4.1.2.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M34.3 24.2s.1.5.5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.3 24.2s.1.5.5.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.2 24.2q0-.2.3-.5l-.2-.4q.1-.3-.1-.5l-.3.6.1.5v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M35.7 22.9a.2.2 0 1 1-.4 0 .2.2 0 0 1 .4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffc72c",
    strokeWidth: 0.2,
    d: "m44.3 11 .9-1.3.9 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M45.4 10.5a.2.2 0 1 1-.4 0 .2.2 0 0 1 .4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M44.4 12H46l-.2-.3c.8-.1.6-.7 1.2-.8l-.3.3s-.4.2-.2.4l.2-.2c0-.1.6-.2.5-.6-.2-.3-1 .2-1 .2h-.6q0-.2-.3-.3l-.3.3h-1.4s0 .4.7.4q.1.3.4.3zm.1-.3h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M44.5 11.7h1.2m-1.3.3H46l-.2-.3c.8-.1.6-.7 1.2-.8l-.3.3s-.4.2-.2.4l.2-.2c0-.1.6-.2.5-.6-.2-.3-1 .2-1 .2h-.6q0-.2-.3-.3l-.3.3h-1.4s0 .4.7.4q.1.3.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M44 11s.1.6.5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M44 11s.1.6.5.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m44 11 .1-.5q-.1-.3 0-.4 0-.3-.3-.5l-.2.7.1.4v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M45.4 9.7a.2.2 0 1 1-.4 0 .2.2 0 0 1 .4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffc72c",
    strokeWidth: 0.2,
    d: "m44.2 13.6.9-1.3 1 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M45.3 13.1a.2.2 0 1 1-.4 0 .2.2 0 0 1 .4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M44.4 14.6h1.4l-.2-.3c.8 0 .6-.7 1.2-.8l-.3.3s-.4.3-.2.4q.2.1.2-.2c0-.1.6-.2.5-.6s-1 .2-1 .2h-.5q0-.2-.4-.3l-.3.3h-1.3s0 .4.6.4q.1.3.4.3zm0-.3h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M44.5 14.3h1.1m-1.2.3h1.4l-.2-.3c.8 0 .6-.7 1.2-.8l-.3.3s-.4.3-.2.4q.2.1.2-.2c0-.1.6-.2.5-.6s-1 .2-1 .2h-.5q0-.2-.4-.3l-.3.3h-1.3s0 .4.6.4q.1.3.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M44 13.6s0 .6.5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M44 13.6s0 .6.5.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m43.9 13.6.2-.5-.2-.4q.1-.2-.1-.5l-.3.7.1.4v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M45.3 12.3a.2.2 0 1 1-.4 0 .2.2 0 0 1 .4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffc72c",
    strokeWidth: 0.2,
    d: "m44 16.3 1-1.3.9 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M45.2 15.8a.2.2 0 1 1-.4 0 .2.2 0 0 1 .4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M44.2 17.3h1.5l-.2-.3c.7-.1.6-.8 1.2-.8l-.4.3q-.2 0-.2.4.2 0 .3-.2c0-.1.6-.2.5-.6-.2-.3-1 .2-1 .2h-.6L45 16q-.4.1-.4.3h-1.3q-.2.1.7.4.1.3.4.3zm.1-.3h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M44.3 17h1.2m-1.3.3h1.5l-.2-.3c.7-.1.6-.8 1.2-.8l-.4.3q-.2 0-.2.4.2 0 .3-.2c0-.1.6-.2.5-.6-.2-.3-1 .2-1 .2h-.6L45 16q-.4.1-.4.3h-1.3q-.2.1.7.4.1.3.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M43.8 16.3s.1.6.5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M43.8 16.3s.1.6.5.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m43.7 16.3.2-.5-.1-.4q.1-.3-.2-.5l-.2.7.1.4v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M45.1 15a.2.2 0 1 1-.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffc72c",
    strokeWidth: 0.2,
    d: "m44.2 19 1-1.4.8 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M45.3 18.4a.2.2 0 1 1-.4 0 .2.2 0 0 1 .4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M44.4 20h1.4l-.2-.4c.8 0 .6-.7 1.2-.8l-.3.3s-.4.3-.2.4q.2.1.2-.2c0-.1.6-.2.5-.6s-1 .2-1 .2h-.5q0-.2-.4-.3l-.3.3h-1.3q-.1.2.6.4.2.3.4.3zm0-.4h1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M44.5 19.6h1.2m-1.3.3h1.4l-.2-.3c.8 0 .6-.7 1.2-.8l-.3.3s-.4.3-.2.4q.2.1.2-.2c0-.1.6-.2.5-.6s-1 .2-1 .2h-.5q0-.2-.4-.3l-.3.3h-1.3q-.1.2.6.4.2.3.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M44 19s0 .5.5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M44 19s0 .5.5.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m43.9 19 .2-.6-.2-.4q.2-.2-.1-.5l-.3.7.1.4v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M45.3 17.6a.2.2 0 1 1-.4 0 .2.2 0 0 1 .4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffc72c",
    strokeWidth: 0.2,
    d: "m44.2 21.6.9-1.4.9 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M45.3 21a.2.2 0 1 1-.4 0 .2.2 0 0 1 .4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M44.3 22.5h1.5l-.2-.2c.8-.1.6-.8 1.2-.8l-.4.2q-.2.1-.1.4 0 .2.2-.2s.6-.2.5-.5c-.2-.3-1 .2-1 .2h-.6q0-.3-.3-.4-.4.2-.4.4h-1.3q-.2.1.7.4.1.2.4.3zm.1-.2h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M44.4 22.3h1.2m-1.3.2h1.5l-.2-.2c.8-.1.6-.8 1.2-.8l-.4.2q-.2.1-.1.4 0 .2.2-.2s.6-.2.5-.5c-.2-.3-1 .2-1 .2h-.6q0-.3-.3-.4-.4.2-.4.4h-1.3q-.2.1.7.4.1.2.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M44 21.6s0 .5.4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M44 21.6s0 .5.4.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m43.8 21.6.2-.6-.1-.3q.1-.3-.2-.5l-.2.6.1.5v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M45.3 20.3a.2.2 0 1 1-.4 0 .2.2 0 0 1 .4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffc72c",
    strokeWidth: 0.2,
    d: "M44.2 24.2 45 23l1 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M45.3 23.7a.2.2 0 1 1-.4 0 .2.2 0 0 1 .4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M44.4 25.2h1.4l-.2-.3c.8-.1.6-.7 1.2-.8l-.3.3s-.4.3-.2.4q.2.1.2-.2c0-.1.6-.2.5-.6s-1 .2-1 .2h-.5q0-.2-.4-.3l-.3.3h-1.3s0 .4.6.4q.1.3.4.3zm0-.3h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M44.5 25h1.1m-1.2.2h1.4l-.2-.3c.8-.1.6-.7 1.2-.8l-.3.3s-.4.3-.2.4q.2.1.2-.2c0-.1.6-.2.5-.6s-1 .2-1 .2h-.5q0-.2-.4-.3l-.3.3h-1.3s0 .4.6.4q.1.3.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M44 24.2s0 .6.5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M44 24.2s0 .6.5.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m43.9 24.2.2-.5-.2-.4q.1-.3-.1-.5l-.3.7.1.4v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M45.3 23a.2.2 0 1 1-.4 0 .2.2 0 0 1 .4 0Zm-3.9 2.5s.3.8.7.3c.5-.5.3-.8.3-.8l-1-.5-.2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc6b5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M42.2 25.3q.1-.2-.1-.3v.3Zm-2.2-.2-.8.5h-.4q0-.2.2-.2c.2 0 .8-.5.8-.5zm0-14.7v.3l-.1.3v.7l.5.2v.4l-.3.6 1.6-.2-.3-.5-.1-.4v-1.6L40 10zm-.2 2.3s-.6.3-.5.9l-.2 1.2-.8 1-.6.8c0 .2-.5.6-.5.8 0 .1 0 .9.3 1l.5-.9-.1-.4q0-.3.2-.4l.8-.6.6-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M40.3 12.2s.2.4.5.3l.6-.3h.3s.8.8.8 1l-.5.3q-.2.3-.2.8l.2.7-.2.2.1.4v2.9l.7 3v.2c-.2 0 .2.4.2.6l.4 1.3-.1.5s.2.6.1.7l-.4.1h-.1l-.1.1h-.7l-.3.3-.2-.2v.2c0 .1-.5.2-.6 0V25l-.3-.1.1.2-.3.2-.5-.3-.5.1-.5.1-.2-.2.1-.4v-.3l.2-.5v-1.9l-.3-.1.4-3.2.2-.8H39l.5-1.7v-1.6q-.2 0-.4-.4l.4-.8.2-.6q0-.2.6-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m40.2 25.2-1.1.6q-.4-.1-.1-.2h.3l-.3-.4.5-.1.2.2.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc6b5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M41.6 25.5q0 .3.3.2t0-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc6b5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M42 25.5h.2l-.2-.3-.1.2zm.4-12.3.4 1.3c0 .3.2 1.3.1 1.4 0 .2-.6.8-.6 1l-.4.9-.2.6.1.3-.4.3-.3-.3V18c.2-.1.6-1.2.7-1.3l.4-1.1-.2-.7q-.6-1.4.4-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c5100",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M40 10.3h.7l.2.2v.4h.2v.7l.2.2q0 .2.2.2.3-.1.2-.2l.2-.2.2-.2q.2 0 0-.4c0-1.4-1-1.3-1-1.3l-.3-.2-.4.2h-.1l-.2.2-.3.2q.1.4.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M41.7 12.6s-1 .6-1 .8m1.2-.6-.2.2m.5 0s-.5.4-.4.6m-1.8-1v.4l.2.6v.4m-.4-.9v.4q.3.1.3.4m-.4.6q.1.2.5-.4m.4-.4s-.2.5.2.7q.4.3.7.1l.3-.1m-1.3 0s0 .6 1 1.3m-1-.7s0 .6.4.8m-.6-1.5s-.3.9-.5 1m.4-.4v.9m-.2.1q0 .2.5.3l.4-.3.7.2m-.5.2v.6c.2 0 .1.5.1.5m-1.4-1.3v.7l-.2.7m-.4.3.2-.2m.1.1s-.4 1.9-.3 3m.4-2.9s-.2 1.4 0 1.7m0-1.7h.8m.1-.1.6.1m-.7.6-.1 3m1.4-2.5s.2 2.2.4 2.4m-1-2.1.3 2m-2.6.7.6-.4c.4.4.9 0 .9 0s.7.5 1 0c.6.3.9-.1.9-.1l.3.3m-.8.2s.4 1.8 1 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39.6 21.7s0 1.5.2 2.6m-.3-.9v1.1m-.6.1s.2.5.7 0c.6-.3.6.2.6.3s.1.5.3.1m.5-.6s-.1 1 .7.3 1 0 1 .2M41 9.9s0 .5.4.5l.1.3m.4.3q.2 0 0 .3m-.7 0 .2.2h.5m-1.3.2s.3.2.5-.4m-1.2-.1h.2m-2.4 6.4v.5m-.5-.5.3.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M40 11.4h.1-.1m1 7.2.3.3q.3-.5.4-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "M40.2 10.8h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M40.4 28.8a10 10 0 0 0 7-3.2s.6-1 1-.8c.6.1 1.3 1.5 2 1.8.5.7 0 1.3-.2 1.4s-1 .5-1.1 0q-.3-.6-.4-.4s-3.8 3.8-8.3 3.6c-4.5 0-8.3-3.6-8.3-3.6l-.4.4-.5.3c-.2 0-1-.5-1-1s.5-.9.5-.9 1.3-1 1.4-1.5c.3-.3.9.2.9.2s3.5 4 7.4 3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M30.6 26.5h.5c0 .2 1 1.1 1 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m31.4 27-.4.2s1 .2.7.8m18.5-1.5h-.5l-1 1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m49.4 26.9.4.3s-.9 0-.7.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m35.1 27.5-.4.1-1.1.7.3-1.5v-.3l.6.4h-.1l-.2.1-.2 1 .8-.5v-.3zm.5 2-.8-.3h.3l.2-.5.4-.7v-.2h-.1l.7.3H36l-.3.5-.4.7zm2.7-.6-.2.5v-.1l-.5-.6q-.3 0-.5.2l-.3.8.2.4.4.1.2-.4-.2-.1.8.2H38l-.1.2-.1.3-1-.2q-.5-.2-.3-.9 0-.4.4-.6t.8 0q.2 0 .3.2zm1.2 1.8h-.9l.3-.1v-.4l.2-1H39l-.1-.1h.8v.1h-.2v.4l-.2 1v.1zm2.2-.5v.6h-1.5l.2-.1v-1.3l-.2-.1.8-.1-.2.1v1.3l.2.1h.3q.3 0 .3-.4m1.1-1.4-.2 1.5q0 .2-.2.3h.6l-.2-.1-.1-.2V30l.6-.2.2.3-.1.2.7-.2h-.1l-.4-.5zm0 .6.4.5-.5.1zm2.5-1.7.2.4h-.1L45 28l.6 1.2.2.1h.1l-.3.2-.4.2v-.3l-.6-1.1-.3.2v.3l-.2-.4zm1-.6.4.6.1-.3V27v.1l.5.6H47q0-.2-.3-.1v.1l.3.4h.2q.3-.2.3-.5v-.2l.3.4-1.2.8q.2 0 0-.3l-.7-1h-.2l1-.8.3.4q-.2-.2-.4 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 34.3,
    x2: 33.6,
    y1: 10.6,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 34.2,
    x2: 33.5,
    y1: 13.2,
    y2: 13.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 34.2,
    x2: 33.5,
    y1: 15.9,
    y2: 15.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 35.9,
    x2: 35.2,
    y1: 18.7,
    y2: 18.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 34,
    x2: 33.3,
    y1: 21,
    y2: 20.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 34,
    x2: 33.3,
    y1: 23.8,
    y2: 23.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 43.7,
    x2: 43,
    y1: 10.6,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 43.7,
    x2: 42.9,
    y1: 13.2,
    y2: 13.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 43.5,
    x2: 42.8,
    y1: 15.9,
    y2: 15.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 43.7,
    x2: 42.9,
    y1: 18.5,
    y2: 18.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 43.6,
    x2: 42.9,
    y1: 21.2,
    y2: 21.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 43.7,
    x2: 42.9,
    y1: 23.8,
    y2: 23.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVg);
export default __webpack_public_path__ + "static/media/vg.b91745b7c41369b1afe9021a5551a745.svg";
export { ForwardRef as ReactComponent };